import { NewMandant } from "./generalType";


// Default global state
export interface LoginState {
    model:{
        client:NewMandant
        }
    view:{
        loginStatus: boolean, 
    }
}

// initialise the default values
export const LoginInitialState : LoginState = {
    model:{
        client:
        {
            name:"Mandant",
            description:"",
            customername:"",
            customerphone:"",
            customermail:"",
            customercompany:"",
            contactname:"",
            contactlastname:"",
            contactstreet:"",
            contactcity:"",
            contactpostcode:"",
            contactcountry:"",
            contactmail:"",
            contactphone:"",
            contacttitle:"",
        }
    },
    view:{
        loginStatus: false, 
    }
}

//write a deep for all state related variables
export function deepCopyThingyState(toCopy:LoginState):LoginState{
    return {
        model:{
            client:{...toCopy.model.client}
        },
        view:{
            loginStatus:toCopy.view.loginStatus,
        }
    }
}



export function deepCopyThingyStateAndMerge(toCopy:LoginState,FormData:any):LoginState{
    const deepCopy = deepCopyThingyState(toCopy);

//    deepCopy.model.newuser = deepCopy.model.user[0];
    // console.log("FormData");
    
    if (FormData.type === "name")
        deepCopy.model.client.name = FormData.data
    if (FormData.type === "description")
        deepCopy.model.client.description = FormData.data
    if (FormData.type === "customername")
         deepCopy.model.client.customername = FormData.data
    if (FormData.type === "customerphone")
         deepCopy.model.client.customerphone = FormData.data
    if (FormData.type === "customermail")
         deepCopy.model.client.customermail = FormData.data
    if (FormData.type === "customercompany")
         deepCopy.model.client.customercompany = FormData.data
    if (FormData.type === "contactname")
         deepCopy.model.client.contactname = FormData.data
    if (FormData.type === "contactlastname")
         deepCopy.model.client.contactlastname = FormData.data
    if (FormData.type === "contactstreet")
         deepCopy.model.client.contactstreet = FormData.data
    if (FormData.type === "contactcity")
         deepCopy.model.client.contactcity = FormData.data
    if (FormData.type === "contactpostcode")
         deepCopy.model.client.contactpostcode = FormData.data
    if (FormData.type === "contactcountry")
         deepCopy.model.client.contactcountry = FormData.data
    if (FormData.type === "contactmail")
         deepCopy.model.client.contactmail = FormData.data
    if (FormData.type === "contactphone")
        deepCopy.model.client.contactphone = FormData.data
    if (FormData.type === "contacttitle")
        deepCopy.model.client.contacttitle = FormData.data
         return deepCopy;
}



